import { css } from '@emotion/react'
import { medium } from '../GlobalStyles'

export const TitleStyling = css`

    display: flex;
    align-items: center;
    padding-top: .8em;
    padding-bottom: .8em;
    border-bottom: 1px solid rgb(230, 236, 241);
    margin-bottom: 32px;

    h1{
        font-family: "helvetica neue", helvetica, Arial, sans-serif;
        font-size: 32px;
        line-height: 1.5;
        font-weight: 300;
        color: var(--cool-gray);
        letter-spacing: 1px;
        border-left: 4px solid var(--primary-color);
        padding: 0 16px;
        flex: 1;
        margin-top: 0;
        padding-top: 0;
        ${medium}{
            font-size: 28px;
        }
    }


`

export const MainWrapperStyle = css`

    max-width: 750px;
    min-width: 750px;

    ${medium}{
        max-width: 100%;
        min-width: 100%;
    }

    ul, ol {
        -webkit-padding-start: 40px;
        -moz-padding-start: 40px;
        -o-padding-start: 40px;
        margin: 24px 0px;
        padding: 0px 0px 0px 2em;

        li{
            font-size: 16px;
            line-height: 1.8;
            font-weight: 400;
        }
    }
    strong{
        font-weight: 900;
    }


`

export const NextPreviousWrapperStyle = css`
    padding: 50px 0;
`